module.exports = __webpack_public_path__ + "img/lorenzo.87b941a0.svg";